/*
* Vast Search Plugin
* Author: Kody Emery
* Version 1.1.1 2015-10-22
*/
(function( $ ) {
    $.fn.vastSearchForm = function(options) {
        if (!options.domain) return false;
        var $block = this;
        var settings = $.extend({
        }, options );
        
        // Vast Make Data
        $.ajaxSetup({cache: true});
        $.ajax({
            url: 'http://'+settings.domain+'/api/models/all',
            jsonp: 'callback',
            dataType: 'jsonp',
            success: function( makes ) {
                $vastMakes = makes;
                // Build out Makes select list
                $.each(Object.keys($vastMakes), function(i, o){
                    var oMake = o.replace('+',' ').replace('-',' ');
                    var oMakeID = o;
                    $('.vast-makes', $block).append($('<option>').text(oMake).attr('data-make',oMake).attr('data-id',oMakeID)); 
                });
            }
        });
        
        // When a user selects a make, re-populate models based on that selection
        $('.vast-makes', $block).on('change', function(){
            var getMake = $('.vast-makes option:selected', $block).data('id');
            if( getMake ) {
                var getModels = $vastMakes[getMake];
                $('.vast-models', $block).html('<option value="">Please Choose</option>');
                $.each(getModels, function(i, o){
                    $('.vast-models', $block).append($('<option>').text(o.label).attr('data-id',o.id)); 
                });
                if( !$('.vast-body option:selected', $block).val() ) $('.vast-models', $block).removeAttr('disabled');
            } else {
                //disable Models if there is no matching make or no models under (shouldn't happen)
                $('.vast-models').attr('disabled','disabled');
            }
        });
        
        $('.vast-models', $block).on('change', function(){
            //disable Body if model is selected
            var getModel = $('.vast-models option:selected', $block).val();
            if( getModel ) { $('.vast-body', $block).attr('disabled','disabled'); }
            else { $('.vast-body', $block).attr('disabled',false); }
        });
        
        $('.vast-body').on('change', function(){
            //disable model is body is selected
            var getBody = $('.vast-body option:selected', $block).val();
            if( getBody ) { $('.vast-models', $block).attr('disabled','disabled'); }
            else { $('.vast-models', $block).attr('disabled',false); }
        });

        // Submit Form
        $('.vast-submit', $block).on('click', function(){
            var sLoc = $('.vast-location', $block).val();
            var sMake = $('.vast-makes option:selected', $block).data('id');
            var sModel = $('.vast-models option:selected', $block).data('id');
            var sBody = $('.vast-body', $block).val();
            var sCondition = '';
            
            sMake = sMake ? '/make-'+sMake: '';
            sModel = sModel ? '/model-'+sModel : '';
            sBody = sBody ? '/body-'+sBody : '';
            var vastLocation = sLoc ? sLoc : settings.location;
            var sLocation= '/location-'+vastLocation;
        
            var sConditionItems = $('.vast-condition:checked', $block);
            if( sConditionItems.length > 0 ){
                $.each(sConditionItems,function(){
                    sCondition += $(this).val()+',';
                });
                sCondition = '/vcond-'+sCondition;
            }
        
            var sUrl = 'http://'+settings.domain+'/search'+sMake+sModel+sLocation+sBody+sCondition;
                
            window.location.href = sUrl;
        });          
    };     
}( jQuery ));

/*
* Vast Featured Vehicles Plugin
* Author: Kody Emery
* Version 1.1.1 2015-10-22
*/
(function( $ ) {
    $.fn.vastFeaturedVehicles = function(options) {
        var $block = this;
        if (!options.domain) return false;
        var settings = $.extend({
            display: 'carousel',
            details: true,
            show_dealer: true,
            random: true,
            featured: true,
            has_image: true,
            target: '.vehicle-items',
            
            /* carousel settings */
            loop:true,
            items: 1,
            autoplay: true,
            autoplayHoverPause: true
        }, options );
        
        var vastDomain = 'http://'+settings.domain;
        var vastUrl = vastDomain+'/'+(settings.dealer?'cars/api/dealer/'+settings.dealer+'/':'search/api/');
        if( settings.location && !settings.dealer ){ vastUrl += 'location-'+settings.location+'/'; }
        if( settings.featured ){ vastUrl += 'lee_featured-yes/'; }
        if( settings.has_image ){ vastUrl += 'has_image-yes/'; }
        
        function shuffleVast(o){
            for(var j, x, i = o.length; i; j = parseInt(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x);
            return o;
        }
        
        function vastVehicles(i, o){
            html = '<div class="item '+((i%2==0 && settings.display == 'grid')?'alpha':'omega')+'">';
            
            html += '<div class="media">';
            if( o.images.imageCount > 0 ){
                html += '<div class="media-left vehicle-image">';
                html += '<a href="'+vastDomain+o.url+'"><img src="'+o.images.large+'" class="img-responsive media-object" alt="'+o.title+'"></a>';
                html += '</div>';
            }
            html += '<div class="media-body vehicle-info">';
            html += '<h4 class="media-heading"><a href="'+vastDomain+o.url+'">'+o.title+'</a></h4>';
            html += '<h5 class="price text-primary">'+o.price.label+'</h5>';
            if( settings.details ){
                html += '<div class="details small">';
                if (o.vehicle_condition) html += '<div>Condition: <strong>'+o.vehicle_condition+'</strong></div>';
                if (o.mileage) html += '<div>Mileage: <strong>'+o.mileage+'</strong></div>';
                if (o.mpg_city || o.mpg_highway) html += '<div>MPG (city/hwy): <strong>'+o.mpg_city+'/'+o.mpg_highway+'</strong></div>';
                if (o.engine) html += '<div>Engine: <strong>'+o.engine+'</strong></div>';
                if (o.transmission) html += '<div>Trans: <strong>'+o.transmission+'</strong></div>';
                if (o.exterior_color) html += '<div>Color: <strong>'+o.exterior_color+'</strong></div>';
                html += '<div class="clear"></div>';
                html += '</div>';
            }
            if( settings.show_dealer && o.dealer ){
                html += '<div class="media vehicle-dealer">';
                if( o.dealer.logourl ){
                    html += '<div class="media-left dealer-logo">';
                    html += '<a href="'+vastDomain+o.dealer.url+'">';
                    html += '<img src="'+o.dealer.logourl+'" class="img-responsive">';
                    html += '</a>';
                    html += '</div>';
                }
                html += '<div class="media-body '+( o.dealer.logourl?'':'no-logo ')+'dealer-info">';
                html += '<h6 class="media-heading dealer-name"><a href="'+vastDomain+o.dealer.url+'">'+o.dealer.name+'</a></h6>';
                html += '<div class="dealer-more small"><a href="'+vastDomain+o.dealer.url+'">View Inventory »</a></div>';
                html += '</div>';
                html += '</div>';
            }
            html += '</div>';
            html += '</div>';
            html += '</div>';            
            html += '</div>';
            if (i % 2 != 0 && settings.display == 'grid'){ html += '<div style="clear:both"></div>'; }
            return html;
        }
        $.ajaxSetup({cache: true});
        $.ajax({
            url: vastUrl,
            dataType: 'jsonp',
            success: function( featured ) {
                if( featured.results.length > 0 ){
                    var vehicles = settings.random ? shuffleVast(featured.results) : featured.results;
                    var vHtml = '';
                    $.each(vehicles, function(i, o){
                        if( i === settings.limit ) return false;
                        if( i < settings.limit ) vHtml += vastVehicles(i, o);
                    });
                    
                    //Turn on Carousel
                    if (settings.display == 'grid'){
                        $(settings.target, $block).html(vHtml);
                    }else{
                        $(settings.target, $block).html(vHtml).owlCarousel({
                            loop: settings.loop,
                            items: settings.items,
                            slideBy: 'page',
                            autoplay: settings.autoplay,
                            autoplayHoverPause: settings.autoplayHoverPause,
                            responsiveClass:true,
                            responsiveBaseElement: settings.target,
                            responsive: {
                                // breakpoint from 0 up
                                0 : { items: 1 },
                                // breakpoint from 768 up
                                768 : { items: 2 },
                                // breakpoint from 768 up
                                922 : { items: 3 }
                            }
                        });
                    }
                    
                }
            }
        });
        
        $(window).resize(function(){
            $target = $(settings.target, $block);
            if ( $target.innerWidth() < 400 ){
                $target.addClass('vehicle-small');
            }else{
                $target.removeClass('vehicle-small');
            }
        });
        $(window).trigger('resize');        
    };     
}( jQuery ));